import DevelopmentPlan from 'development-plan/components/DevelopmentPlan';
import Goals from 'development-plan/components/Goals';
import { useDevelopmentPlanQuery } from 'generated/graphql';

export default function EvaluationSubmissionItemDevelopmentPlan({ userID }: { userID: string }) {
	const query = useDevelopmentPlanQuery({
		variables: { userID },
	});

	return (
		<>
			{query.loading && <DevelopmentPlan.Skeleton />}
			{query.data?.user && (
				<Goals
					onSave={() => {
						query.refetch();
					}}
					user={query.data.user}
				/>
			)}
		</>
	);
}
